import React, { useState, useEffect } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'

export default function TextInputComponent(props) {
  const {
    textInputData,
    x,
    y,
    onValueChange,
    defaultValue,
    isPractice,
    completed,
    isActive,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    isVerifyMode,
    explanationClick,
    onExplanationVisible,
    handleSuccessChange,
    handleSucAndFailFeedback,
    isAudioPlaying
  } = props
  const {
    CorrectAnswer,
    Type,
    MaxValue,
    MinValue,
    ControlID,
    Width,
    Height,
    Rotation,
    CaseSensitive,
    Weight,
    Priority,
    SequenceHint,
    FontFamily,
    FontSize,
    FontColor,
    FillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    TextAlign,
    FeedbackAudioData
  } = textInputData
  const [answerText, setAnswerText] = useState('')
  const [checkAnswer, setCheckAnswer] = useState(false)
  const [priorityValue, setPriorityValue] = useState(0)
  const [boxFocused, setBoxFocused] = useState(false)
  const [failureCount, setFailureCount] = useState(0)

  useEffect(() => {
    if (defaultValue) {
      setAnswerText(defaultValue)
      if (completed === 1 || isPractice) {
        if (Type === 'range') {
          if (CorrectAnswer === defaultValue) {
            setCheckAnswer(true)
          } else if (
            parseFloat(defaultValue) >= parseFloat(MinValue) &&
            parseFloat(defaultValue) <= parseFloat(MaxValue)
          ) {
            setCheckAnswer(true)
          } else {
            setCheckAnswer(false)
          }
        } else {
          if (!CaseSensitive) {
            if (CorrectAnswer === defaultValue) {
              setCheckAnswer(true)
            } else {
              setCheckAnswer(false)
            }
          } else {
            if (CorrectAnswer.toLowerCase() === defaultValue.toLowerCase()) {
              setCheckAnswer(true)
            } else {
              setCheckAnswer(false)
            }
          }
        }
      }
    } else {
      setAnswerText('')
    }
  }, [defaultValue, isPractice])

  useEffect(() => {
    setPriorityValue(currentPriority)
  }, [currentPriority])

  //Failure message Sequence
  function handleFailureFeedback() {
    let feedbackAudioData = FeedbackAudioData.failureData
    let failureFeedback = {}
    if (feedbackAudioData.length > 0) {
      if (failureCount === 0) {
        setFailureCount(1)
        failureFeedback = feedbackAudioData[0]
      } else if (failureCount === 1) {
        setFailureCount(2)
        failureFeedback = feedbackAudioData[1]
      } else if (failureCount === 2) {
        setFailureCount(0)
        failureFeedback = feedbackAudioData[2]
      }
    } else {
      failureFeedback = {
        failureAudioLink: '',
        failureFeedback: []
      }
    }
    handleSucAndFailFeedback(false, failureFeedback)
  }

  function validateCorrectAnswer(correctAnswerJson) {
    const isRangeType = Type === 'range'
    const isCaseInsensitiveMatch =
      !CaseSensitive &&
      correctAnswerJson.toLowerCase() === answerText.toLowerCase()
    const isExactMatch =
      correctAnswerJson === answerText || isCaseInsensitiveMatch
    const isWithinRange =
      isRangeType &&
      parseFloat(answerText) >= parseFloat(MinValue) &&
      parseFloat(answerText) <= parseFloat(MaxValue)
    const isValidAnswer = isExactMatch || isWithinRange

    if (followTheFlow) {
      if (answerText !== '') {
        if (isPractice) {
          if (isValidAnswer) {
            handleSucAndFailFeedback(true, FeedbackAudioData.successData)
          } else {
            handleFailureFeedback()
          }
        } else {
          onPriorityChange(Priority, ControlID)
        }
      } else {
        setAnswerText(defaultValue)
      }
    } else {
      if (answerText === '') setAnswerText(defaultValue)
    }

    if (!followTheFlow) {
      setCheckAnswer(isValidAnswer)
      onValueChange(
        { Answer: answerText, Value: isValidAnswer ? Weight : 0 },
        ControlID
      )
      handleSuccessChange(isValidAnswer)
      return isValidAnswer
    } else {
      if (answerText !== '') {
        setCheckAnswer(isValidAnswer)
        onValueChange(
          { Answer: answerText, Value: isValidAnswer ? Weight : 0 },
          ControlID
        )
        return isValidAnswer
      } else {
        const isDefaultWithinRange =
          isRangeType &&
          parseFloat(defaultValue) >= parseFloat(MinValue) &&
          parseFloat(defaultValue) <= parseFloat(MaxValue)
        const isDefaultMatch =
          correctAnswerJson === defaultValue ||
          (!CaseSensitive &&
            correctAnswerJson.toLowerCase() === defaultValue.toLowerCase())
        const isValidDefault = isDefaultMatch || isDefaultWithinRange
        setCheckAnswer(isValidDefault)
        onValueChange(
          { Answer: defaultValue, Value: isValidDefault ? Weight : 0 },
          ControlID
        )
        return isValidDefault
      }
    }
  }

  // function validateCorrectAnswer(correctAnswerJson) {
  //   if (followTheFlow) {
  //     if (answerText !== '') {
  //       if (isPractice) {
  //         if (Type === 'range') {
  //           if (
  //             correctAnswerJson === answerText ||
  //             (parseFloat(answerText) >= parseFloat(MinValue) &&
  //               parseFloat(answerText) <= parseFloat(MaxValue))
  //           ) {
  //             onPriorityChange(Priority, ControlID)
  //           }
  //         } else {
  //           if (!CaseSensitive) {
  //             if (correctAnswerJson === answerText) {
  //               onPriorityChange(Priority, ControlID)
  //             }
  //           } else {
  //             if (
  //               correctAnswerJson.toLowerCase() === answerText.toLowerCase()
  //             ) {
  //               onPriorityChange(Priority, ControlID)
  //             }
  //           }
  //         }
  //       } else {
  //         onPriorityChange(Priority, ControlID)
  //       }
  //     } else {
  //       setAnswerText(defaultValue)
  //     }
  //   } else {
  //     if (answerText === '') {
  //       setAnswerText(defaultValue)
  //     }
  //   }
  //   if (!followTheFlow) {
  //     if (Type === 'range') {
  //       if (correctAnswerJson === answerText) {
  //         setCheckAnswer(true)
  //         onValueChange({ Answer: answerText, Value: Weight }, ControlID)
  //         handleSuccessChange(true)
  //         return true
  //       } else if (
  //         parseFloat(answerText) >= parseFloat(MinValue) &&
  //         parseFloat(answerText) <= parseFloat(MaxValue)
  //       ) {
  //         setCheckAnswer(true)
  //         onValueChange({ Answer: answerText, Value: Weight }, ControlID)
  //         handleSuccessChange(true)
  //         return true
  //       } else {
  //         setCheckAnswer(false)
  //         onValueChange({ Answer: answerText, Value: 0 }, ControlID)
  //         handleSuccessChange(false)
  //         return false
  //       }
  //     } else {
  //       if (!CaseSensitive) {
  //         if (correctAnswerJson === answerText) {
  //           setCheckAnswer(true)
  //           onValueChange({ Answer: answerText, Value: Weight }, ControlID)
  //           handleSuccessChange(true)
  //           return true
  //         } else {
  //           setCheckAnswer(false)
  //           onValueChange({ Answer: answerText, Value: 0 }, ControlID)
  //           handleSuccessChange(false)
  //           return false
  //         }
  //       } else {
  //         if (correctAnswerJson.toLowerCase() === answerText.toLowerCase()) {
  //           setCheckAnswer(true)
  //           onValueChange({ Answer: answerText, Value: Weight }, ControlID)
  //           handleSuccessChange(true)
  //           return true
  //         } else {
  //           setCheckAnswer(false)
  //           onValueChange({ Answer: answerText, Value: 0 }, ControlID)
  //           handleSuccessChange(false)
  //           return false
  //         }
  //       }
  //     }
  //   } else {
  //     if (answerText !== '') {
  //       if (Type === 'range') {
  //         if (correctAnswerJson === answerText) {
  //           setCheckAnswer(true)
  //           onValueChange({ Answer: answerText, Value: Weight }, ControlID)
  //           handleSuccessChange(true)
  //           handleSucAndFailFeedback(true)
  //           return true
  //         } else if (
  //           parseFloat(answerText) >= parseFloat(MinValue) &&
  //           parseFloat(answerText) <= parseFloat(MaxValue)
  //         ) {
  //           setCheckAnswer(true)
  //           onValueChange({ Answer: answerText, Value: Weight }, ControlID)
  //           handleSuccessChange(true)
  //           handleSucAndFailFeedback(true)
  //           return true
  //         } else {
  //           setCheckAnswer(false)
  //           onValueChange({ Answer: answerText, Value: 0 }, ControlID)
  //           handleSuccessChange(false)
  //           handleSucAndFailFeedback(false)
  //           return false
  //         }
  //       } else {
  //         if (!CaseSensitive) {
  //           if (correctAnswerJson === answerText) {
  //             setCheckAnswer(true)
  //             onValueChange({ Answer: answerText, Value: Weight }, ControlID)
  //             handleSuccessChange(true)
  //             handleSucAndFailFeedback(true)
  //             return true
  //           } else {
  //             setCheckAnswer(false)
  //             onValueChange({ Answer: answerText, Value: 0 }, ControlID)
  //             handleSucAndFailFeedback(false)
  //             return false
  //           }
  //         } else {
  //           if (correctAnswerJson.toLowerCase() === answerText.toLowerCase()) {
  //             setCheckAnswer(true)
  //             onValueChange({ Answer: answerText, Value: Weight }, ControlID)
  //             handleSuccessChange(true)
  //             handleSucAndFailFeedback(true)
  //             return true
  //           } else {
  //             setCheckAnswer(false)
  //             onValueChange({ Answer: answerText, Value: 0 }, ControlID)
  //             handleSuccessChange(false)
  //             handleSucAndFailFeedback(false)
  //             return false
  //           }
  //         }
  //       }
  //     } else {
  //       if (Type === 'range') {
  //         if (correctAnswerJson === defaultValue) {
  //           setCheckAnswer(true)
  //           onValueChange({ Answer: defaultValue, Value: Weight }, ControlID)
  //           handleSuccessChange(true)
  //           handleSucAndFailFeedback(true)
  //           return true
  //         } else if (
  //           parseFloat(defaultValue) >= parseFloat(MinValue) &&
  //           parseFloat(defaultValue) <= parseFloat(MaxValue)
  //         ) {
  //           setCheckAnswer(true)
  //           onValueChange({ Answer: defaultValue, Value: Weight }, ControlID)
  //           handleSuccessChange(true)
  //           handleSucAndFailFeedback(true)
  //           return true
  //         } else {
  //           setCheckAnswer(false)
  //           onValueChange({ Answer: defaultValue, Value: 0 }, ControlID)
  //           handleSuccessChange(false)
  //           handleSucAndFailFeedback(false)
  //           return false
  //         }
  //       } else {
  //         if (!CaseSensitive) {
  //           if (correctAnswerJson === defaultValue) {
  //             setCheckAnswer(true)
  //             onValueChange({ Answer: defaultValue, Value: Weight }, ControlID)
  //             handleSuccessChange(true)
  //             handleSucAndFailFeedback(true)
  //             return true
  //           } else {
  //             setCheckAnswer(false)
  //             onValueChange({ Answer: defaultValue, Value: 0 }, ControlID)
  //             handleSuccessChange(false)
  //             handleSucAndFailFeedback(false)
  //             return false
  //           }
  //         } else {
  //           if (
  //             correctAnswerJson.toLowerCase() === defaultValue.toLowerCase()
  //           ) {
  //             setCheckAnswer(true)
  //             onValueChange({ Answer: defaultValue, Value: Weight }, ControlID)
  //             handleSuccessChange(true)
  //             handleSucAndFailFeedback(true)
  //             return true
  //           } else {
  //             setCheckAnswer(false)
  //             onValueChange({ Answer: defaultValue, Value: 0 }, ControlID)
  //             handleSuccessChange(false)
  //             handleSucAndFailFeedback(false)
  //             return false
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  return (
    <span
      style={{
        width: Width + '%',
        height: Height + '%',
        left: x,
        top: y,
        position: 'absolute',
        transform: `rotate(${Rotation + 'deg'})`,
        zIndex: 5,
        borderRadius: '4px',
        padding: '3px',
        filter: followTheFlow
          ? Priority <= currentPriority
            ? 'unset'
            : 'blur(3px)'
          : 'unset',
        pointerEvents:
          completed === 1 || !isActive || isAudioPlaying
            ? 'none'
            : followTheFlow
            ? isPractice
              ? Priority === currentPriority
                ? 'auto'
                : 'none'
              : Priority > currentPriority
              ? 'none'
              : 'auto'
            : 'auto'
      }}
    >
      <input
        className='Rectangle-2091'
        autoComplete='off'
        type='text'
        id={'pnNo' + Priority}
        style={{
          width: '100%',
          height: '100%',
          borderColor:
            defaultValue && defaultValue !== ''
              ? isPractice || completed === 1 || !isActive
                ? checkAnswer
                  ? '#3EC986'
                  : '#ff551f'
                : '#b5b5b5'
              : '#b5b5b5',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderRadius: '4px',
          zIndex: 5,
          fontSize:
            FontSize === 'SMALL'
              ? SMALL_DESKTOP
              : FontSize === 'LARGE'
              ? LARGE_DESKTOP
              : MEDIUM_DESKTOP,
          fontFamily: FontFamily,
          fontStyle: textInputData.Italic ? 'italic' : 'normal',
          fontWeight: textInputData.Bold ? 'bold' : 'normal',
          color: answerText !== '' ? FontColor : 'black',
          backgroundColor:
            answerText !== ''
              ? priorityValue === Priority
                ? '#FFFFFF'
                : FillColor
              : '',
          animationName:
            defaultValue && defaultValue !== '' && defaultValue !== '?'
              ? isPractice || completed === 1
                ? checkAnswer
                  ? 'pulse_animation'
                  : 'shake_animation'
                : 'flip_animation'
              : 'unset',
          animationDuration: '200ms',
          textAlign:
            TextAlign && answerText !== ''
              ? TextAlign === 'left'
                ? 'left'
                : TextAlign === 'right'
                ? 'right'
                : 'center'
              : 'center'
        }}
        // autoFocus
        onBlur={() => {
          setBoxFocused(false)
          if (!explanationClick && answerText !== '') {
            validateCorrectAnswer(CorrectAnswer)
          }
        }}
        onFocus={() => {
          if (!explanationClick && completed === 0 && isActive) {
            setBoxFocused(true)
          }
        }}
        readOnly={
          explanationClick || isAudioPlaying || completed === 1 || !isActive
            ? true
            : isPractice && followTheFlow
            ? checkAnswer
              ? true
              : false
            : false
        }
        value={
          isVerifyMode
            ? Type === 'range'
              ? MaxValue
              : CorrectAnswer
            : answerText === '' && !boxFocused
            ? '?'
            : answerText
        }
        onChange={(e) => setAnswerText(e.target.value)}
        onKeyDown={(ev) => {
          if (ev.key === 'Enter') {
            ev.target.blur()
          } else if (ev.key === 'ArrowDown') {
            ev.target.blur()
          } else if (ev.key === 'Tab') {
            if (ev.target.value.trim().length === 0) {
              ev.preventDefault()
              return
            }
          }
        }}
        onClick={() => {
          // Answer Explanation
          if (explanationClick) {
            if (defaultValue !== '' && checkAnswer) {
              onExplanationVisible(true, CorrectAnswerExplanation)
            } else {
              onExplanationVisible(false, IncorrectAnswerExplanation)
            }
          }
        }}
      />
    </span>
  )
}
